import { getEnvVariable } from './whitelabelEnv';

export const domain = window.location.hostname;
export const BRAND_NAME = getEnvVariable(domain, 'BRAND_NAME');
// Note: It is the main site url. Ex - apnigame.com, etc.
export const BRAND_DOMAIN = getEnvVariable(domain, 'BRAND_DOMAIN');
// Note: It is the main site url. Ex - apnigame.com, etc.
export const BACKEND_DOMAIN = 'stage-core.stwin2025.co';